export const prefix = (type) => (type === "dollar" ? "$ " : "");
export const suffix = (type) => (type === "dollar" ? "" : "%");
